import { useContext, useEffect, useState } from 'react'

import { useQuery } from '@tanstack/react-query'

import { fetchAccountContactActivity, fetchAccountContactCount } from 'api/AccountActivityAPI'
import { PagedContactWithActivities } from 'api/AccountActivityAPI/types'
import { SortContext } from 'context/sortContext'
import { AccountActivitySortValue } from 'modules/accountActivity/domain'

export const useAccountContactActivity = (
  accountId: string,
  limit: number,
  pageNum: number,
  sort?: AccountActivitySortValue,
  fromTime?:number
): {
  response: PagedContactWithActivities | undefined
  count: number | undefined
  accountContactsError: Error | undefined
  isLoading: boolean
} => {
  const [accountContactsError, setError] = useState<Error | undefined>(undefined)

  const { contactsSort, contactsDescending } = useContext(SortContext)

  const [config, setConfig] = useState<{
    currentPage?: number,
    prevPageStartTimestamp?: number
nextPageStartTimestamp?: number
  }>({currentPage: undefined, prevPageStartTimestamp: undefined, nextPageStartTimestamp: undefined })

  const { data: response, error: activityError, isLoading: isLoadingAccountContacts} = useQuery<
  PagedContactWithActivities,
  Error
  >({
    queryKey: [
      'fetchAccountContactActivity',
      accountId,
      contactsSort,
      contactsDescending,
      limit,
      pageNum,
      fromTime
    ],
    queryFn: () =>{
      const fromTime: number | undefined = config.currentPage && config.currentPage > pageNum ? config.prevPageStartTimestamp: config.nextPageStartTimestamp
      
     return  fetchAccountContactActivity({
        accountId,
        sortBy: sort ?? contactsSort,
        descending: contactsDescending,
        limit,
        pageNum,
        fromTime
      }).then(resp => {
        const {prevPageStartTimestamp, nextPageStartTimestamp} = resp
        setConfig({
          currentPage: pageNum,
          prevPageStartTimestamp, nextPageStartTimestamp
        })
        return resp}
      )},
    staleTime: 1000 * 60
  })


  const { data: count, error: countError, isLoading: isLoadingCount } = useQuery<number, Error>({
    queryKey: ['fetchAccountContactCount', accountId],
    queryFn: () => fetchAccountContactCount(accountId).then(resp => resp.data),
    staleTime: 1000 * 60
  })

  useEffect(() => {
    if (activityError) {
      setError(activityError)
    }
    if (countError) {
      setError(countError)
    }
  }, [activityError, countError])

  return {
    response,
    count,
    accountContactsError,
    isLoading: isLoadingAccountContacts || isLoadingCount
  }
}
